<script>
  /** Primarily used for testing
   * @type {string} */
  export let id;

  /** Indicates whether the component should render.
   * @type {boolean} */
  export let shouldRender = false;

  let ref;
  $: ref && document.body.appendChild(ref);
</script>

{#if shouldRender}
  <div {id} bind:this={ref}>
    <slot />
  </div>
{/if}
